import { Component } from '@angular/core';

@Component({
  selector: 'app-compare-section',
  templateUrl: './compare-section.component.html',
  styleUrls: ['./compare-section.component.sass'],
})
export class CompareSectionComponent {}
